import React from 'react';
import { useTranslation } from 'react-i18next';
import InfoTooltip from '@/shared/components/forms/InfoTooltip';

interface TimezoneSelectorProps {
  selectedTimezone: string;
  onTimezoneChange: (timezone: string) => void;
}

const TimezoneSelector: React.FC<TimezoneSelectorProps> = ({
  selectedTimezone,
  onTimezoneChange
}) => {
  const { t } = useTranslation('dataUpload');

  const timezones = [
    { value: 'UTC', label: 'UTC' },
    // Europe
    { value: 'Europe/London', label: 'Europe/London (GMT)' },
    { value: 'Europe/Berlin', label: 'Europe/Berlin (CET)' },
    { value: 'Europe/Vienna', label: 'Europe/Vienna (CET)' },
    { value: 'Europe/Moscow', label: 'Europe/Moscow (MSK)' },
    // Americas
    { value: 'America/New_York', label: 'America/New_York (EST)' },
    { value: 'America/Chicago', label: 'America/Chicago (CST)' },
    { value: 'America/Denver', label: 'America/Denver (MST)' },
    { value: 'America/Los_Angeles', label: 'America/Los_Angeles (PST)' },
    { value: 'America/Sao_Paulo', label: 'America/Sao_Paulo (BRT)' },
    // Asia/Pacific
    { value: 'Asia/Tokyo', label: 'Asia/Tokyo (JST)' },
    { value: 'Asia/Shanghai', label: 'Asia/Shanghai (CST)' },
    { value: 'Asia/Kolkata', label: 'Asia/Kolkata (IST)' },
    { value: 'Asia/Dubai', label: 'Asia/Dubai (GST)' },
    { value: 'Australia/Sydney', label: 'Australia/Sydney (AEST)' },
    { value: 'Pacific/Auckland', label: 'Pacific/Auckland (NZST)' }
  ];

  return (
    <div className="mb-4">
      <label className="dropdown-label">
        {t('timezone.label')}
        <InfoTooltip text={t('tooltips.timezone')} />
      </label>
      <select
        value={selectedTimezone}
        onChange={(e) => onTimezoneChange(e.target.value)}
        className="dropdown-select"
      >
        {timezones.map(tz => (
          <option key={tz.value} value={tz.value}>
            {tz.label}
          </option>
        ))}
      </select>
    </div>
  );
};

export default TimezoneSelector;